import * as React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'

import { useReview } from 'modules/reviews/hooks/useReview'
import type Review from 'modules/reviews/store/models/v2/Review'

// TODO: private component from another page
import Reviewees from './Reviewees'

const RevieweesPage = () => {
  const { id, user_id } = useParams()
  const { loading, review } = useReview(id)

  if (loading) return <Loading />

  if (!loading && !review) return <NotFound />

  return (
    <Reviewees review={review as Review} userId={Number(user_id)}>
      <Outlet />
    </Reviewees>
  )
}

export default RevieweesPage
